// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search_sys_body_result_resultarea_sec img[data-v-f1179ff0]{width:100%}.anchor_like[data-v-f1179ff0]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
